function getValuesByPrefix(nuclide, prefix) {
    let attributes = Object.keys(nuclide).filter(n => n.startsWith(prefix));
    return attributes.map(n => nuclide[n]);
}

export default getValuesByPrefix;